"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Currency = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "3 3 12 12"
}, props), _react.default.createElement("path", {
  d: "M9 3a6 6 0 110 12A6 6 0 019 3zm.403 2h-.826a.259.259 0 00-.179.062.2.2 0 00-.062.099l-.008.061v.622c-.67.083-1.195.29-1.577.623-.381.332-.572.734-.572 1.209 0 .367.093.674.279.92.185.245.456.444.81.595.356.151.785.274 1.29.369.39.071.704.14.94.209.235.068.406.144.512.227.106.083.16.192.16.328 0 .184-.099.33-.294.436-.196.107-.486.16-.871.16-.232 0-.426-.025-.582-.076a1.081 1.081 0 01-.378-.2 1.07 1.07 0 01-.224-.257.528.528 0 00-.134-.116.33.33 0 00-.129-.04l-.085-.004H6.219c-.06 0-.111.019-.154.057a.17.17 0 00-.065.13c.013.272.106.53.279.773.172.243.43.452.77.626.285.146.629.25 1.031.31l.248.033v.622c0 .059.024.11.07.155.031.03.068.05.11.06l.07.007h.825a.253.253 0 00.24-.165l.009-.057v-.622a3.911 3.911 0 001.234-.33c.351-.165.625-.382.82-.648.196-.267.294-.575.294-.925 0-.361-.086-.662-.259-.902-.172-.24-.444-.435-.816-.587-.371-.15-.859-.277-1.462-.377a8.481 8.481 0 01-.861-.205c-.209-.065-.358-.142-.448-.23a.425.425 0 01-.134-.312c0-.19.081-.33.244-.422.162-.092.39-.138.681-.138.266 0 .485.049.657.147.172.097.279.212.318.342a.355.355 0 00.26.147l.069.004h1.313c.06 0 .11-.02.15-.058a.176.176 0 00.06-.129c-.007-.213-.092-.435-.255-.666-.162-.231-.4-.439-.711-.623a3.042 3.042 0 00-.931-.342l-.223-.04v-.64a.199.199 0 00-.075-.16.261.261 0 00-.11-.055L9.403 5z",
  fill: "#ACB3BE",
  fillRule: "evenodd",
  className: "fill"
}));

var _default = Currency;
exports.default = _default;